import { render, staticRenderFns } from "./VisitFrequencyReport.vue?vue&type=template&id=26a40c31&scoped=true"
import script from "./VisitFrequencyReport.vue?vue&type=script&lang=js"
export * from "./VisitFrequencyReport.vue?vue&type=script&lang=js"
import style0 from "./VisitFrequencyReport.vue?vue&type=style&index=0&id=26a40c31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a40c31",
  null
  
)

export default component.exports